module.exports = __webpack_public_path__ + "img/sk_get.83cd181.png";